import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'
import type { KnowledgeKind } from '../../hooks/useKnowledge'

const VARIANTS: Record<KnowledgeKind, 'secondary' | 'warning' | 'info'> = {
    note: 'secondary',
    rule: 'warning',
    procedure: 'info',
}

/** The kind of a knowledge note: display only (a badge and a filter), no workflow. */
export function KindBadge({ kind }: { kind: KnowledgeKind }) {
    const { t } = useTranslation('knowledge')

    return (
        <Badge variant={VARIANTS[kind] ?? 'secondary'} data-testid={`knowledge-kind-${kind}`}>
            {t(`kind.${kind}`)}
        </Badge>
    )
}
